import React, { useState } from "react";
import { Typography, Divider, Button, Box } from "@mui/material";
import { useUpdateTenantLogoMutation } from "../../../features/tenants/tenantsApiSlice";
import { uploadTenantLogoAxios } from "../../../app/api/axios/services/files.service";
import { useDispatch, useSelector } from "react-redux";
import { setDialog } from "../../../features/dialog/dialogSlice";
import { serverURL } from "../../../app/api/axios/http.service";
import { selectCurrentUserData } from "../../../features/auth/authSlice";
import UploadTenantLogoField from "./UploadTenantLogoField";

export default function TenantSettings() {
  const [logo, setLogo] = useState(null);
  // const [website, setWebsite] = useState("");
  const [updateTenantLogo] = useUpdateTenantLogoMutation();
  const currentUserData = useSelector(selectCurrentUserData);
  const dispatch = useDispatch();

  // const handleWebsiteChange = (event) => {
  //   setWebsite(event.target.value);
  // };

  // const handleSaveSettings = () => {
  //   // Add save logic for company settings here
  //   console.log("Settings saved: ", { logo, website });
  // };

  console.log("currentUserData :>> ", currentUserData);

  const handleChangeTenantLogo = async () => {
    console.log("logo :>> ", logo.name);
    try {
      const result = await updateTenantLogo({
        logoName: logo.name,
        tenantId: currentUserData.tenant,
      }).unwrap();
      if (result && result.type === "success") {
        const formData = new FormData();
        formData.append("file", logo);
        const uploadResult = await uploadTenantLogoAxios(
          formData,
          currentUserData.tenant
        );
        if (uploadResult && uploadResult.data.status === "success") {
          dispatch(
            setDialog({
              title: "Logo geändert!",
              type: "SUCCESS",
              reload: true,
              data: {
                successText: "Das Logo der Praxis wurde erfolgreich geändert!",
              },
            })
          );
        }
        console.log("uploadResult :>> ", uploadResult);
      }
      console.log("result :>> ", result);
    } catch (error) {
      console.log("error :>> ", error);
    }
    // change logo url in tenant
    // upload file with response
  };

  return (
    <>
      <Typography variant="h3" sx={{ mb: 2 }}>
        Unternehmen
      </Typography>
      <Divider sx={{ mb: 3 }} />
      <Typography variant="h5" sx={{ mb: 2 }}>
        Aktuelles Logo:
      </Typography>
      <Box
        component="img"
        src={`${serverURL()}/public/tenant/image/${
          currentUserData?.tenant ?? " "
        }`}
        alt="Praxis Logo"
        sx={{
          cursor: "pointer",
          maxWidth: "300px",
          mb: 3,
        }}
      />
      <Divider sx={{ mb: 3 }} />
      <Typography variant="h5" sx={{ mb: 2 }}>
        Neues Logo hochladen:
      </Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Wenn Sie ein neues Logo hochladen möchten, ziehen Sie das Bild in den
        Bereich oder klicken Sie darauf und wählen Sie anschließend das Logo
        aus. <br />
        Wir empfehlen ein Logo mit 120px x 60px.
      </Typography>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Nachdem Sie das Logo ausgewählt haben klicken Sie bitte auf{" "}
        <b>LOGO HOCHLADEN</b> um das Logo zu ändern.
      </Typography>
      <UploadTenantLogoField logo={logo} setLogo={setLogo} />
      {logo && (
        <Button
          sx={{ m: 2, minWidth: 250 }}
          variant="contained"
          color="primary"
          onClick={handleChangeTenantLogo}
        >
          LOGO HOCHLADEN
        </Button>
      )}
      {/* <TextField
        label="Website des Unternehmens"
        variant="outlined"
        value={website}
        onChange={handleWebsiteChange}
        fullWidth
        sx={{ mt: 3, mb: 3 }}
      />
      <Box display="flex" justifyContent="flex-end">
        <Button
          variant="contained"
          color="secondary"
          onClick={handleSaveSettings}
        >
          Einstellungen speichern
        </Button>
      </Box> */}
    </>
  );
}
